module.exports = __webpack_public_path__ + "media/images/about-6fcb902c35fe315eca923bc9499ce7ed.jpg";